import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmNominateUsersLocationUpdatesService {

  constructor(private _httpClient: IesHttpClient) {
  }

  // to get list of Nominee users
  getSearchedNominees(urlParams: any) {
    return this._httpClient.get(AppUrl.getNominee, urlParams);
  }

  // to remove/delete Nominee user
  removeNominee(urlParams: any) {
    return this._httpClient.delete(AppUrl.removeNominee, urlParams);
  }

  // to add/save Nominee users
  addNominee(params: any) {
    return this._httpClient.post(AppUrl.addNominee, params);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-nominate-users-location-updates/adm-nominate-users-location-updates.service.ts